import { Center } from '@zorro/web/design-system';
import React from 'react';

import { SVGIconProps } from '../types';

type Props = {
  style?: SVGIconProps;
  className?: string;
};
export const UsaMapIconBlack = ({ style, className }: Props) => {
  return (
    <Center style={style} className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <g clipPath="url(#clip0_462_17551)">
          <path
            d="M10.6943 2.71289C11.0407 2.71289 11.3223 2.99332 11.3223 3.33984V3.8418H12.3887C12.6765 3.8418 12.9283 4.038 12.998 4.31738L13.4443 6.10156H13.8242L16.4639 3.46094C16.5815 3.34333 16.7417 3.27734 16.9082 3.27734H17.4727C17.819 3.27734 18.0994 3.55797 18.0996 3.9043V6.16406C18.0996 6.26119 18.0777 6.35717 18.0342 6.44434L16.9707 8.57129V10.1182C16.9707 10.2844 16.9037 10.444 16.7861 10.5615L16.1484 11.2002C16.0746 11.274 16.0623 11.3907 16.1201 11.4775L16.8652 12.5938C17.0102 12.8113 17.003 13.0923 16.8574 13.3008L16.7861 13.3857L15.6572 14.5156C15.4122 14.7605 15.0145 14.7605 14.7695 14.5156L13.2588 13.0049H11.6475L11.5381 13.2227C11.4319 13.4352 11.2141 13.5693 10.9766 13.5693H10.582L10.1602 14.835C10.0747 15.0913 9.8345 15.2637 9.56445 15.2637H8.43555C8.22577 15.2637 8.0294 15.1589 7.91309 14.9844L6.96973 13.5693H6.17578C6.05098 13.5693 5.93038 13.532 5.82812 13.4639L5.73242 13.3857L5.35156 13.0049H3.35156C3.21585 13.0049 3.08403 12.9602 2.97559 12.8789L0.71582 11.1846C0.582859 11.0848 0.495209 10.9362 0.47168 10.7715L-0.09375 6.81738C-0.107579 6.72105 -0.0982641 6.62259 -0.0673828 6.53027L1.06152 3.1416C1.14695 2.88548 1.38715 2.71289 1.65723 2.71289H10.6943ZM1.16895 6.78711L1.67578 10.3359L3.56055 11.75H5.61133C5.77755 11.7501 5.93715 11.8161 6.05469 11.9336L6.43555 12.3145H7.30566C7.5152 12.3145 7.71082 12.4196 7.82715 12.5938L8.77148 14.0098H9.1123L9.53418 12.7441C9.61961 12.488 9.85981 12.3145 10.1299 12.3145H10.5889L10.6982 12.0967C10.8046 11.8842 11.0222 11.75 11.2598 11.75H13.5186C13.6849 11.75 13.8443 11.8162 13.9619 11.9336L15.2129 13.1846L15.5352 12.8623L15.0762 12.1738C14.6873 11.5909 14.7649 10.8079 15.2607 10.3125L15.7158 9.85742V8.42383C15.7158 8.32638 15.7386 8.22985 15.7822 8.14258L16.8457 6.01465V4.85352L14.5273 7.17285C14.4098 7.29038 14.2501 7.35636 14.084 7.35645H12.9541C12.6663 7.35645 12.4155 7.1601 12.3457 6.88086L11.8984 5.09668H10.6943C10.3481 5.09658 10.0675 4.81609 10.0674 4.46973V3.9668H2.10938L1.16895 6.78711Z"
            fill="#1A1721"
            stroke="black"
            strokeWidth="0.2"
          />
        </g>
        <defs>
          <clipPath id="clip0_462_17551">
            <rect width="18" height="18" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Center>
  );
};
